import { createSelector } from '@ngrx/store';
import * as fromPaymentsAndInvoicesReducer from '../reducers';
import * as fromPaymentmethod from '../reducers/payment-method.reducer';

export const selectPaymentMethods = createSelector(
  fromPaymentsAndInvoicesReducer.selectPaymentMethodsEntitiesState,
  fromPaymentmethod.selectPaymentMethods
);
export const selectPaymentMethodsIsLoaded = createSelector(
  fromPaymentsAndInvoicesReducer.selectPaymentMethodsEntitiesState,
  fromPaymentmethod.selectPaymentMethodsLoaded
);
export const selectPaymentMethodsError = createSelector(
  fromPaymentsAndInvoicesReducer.selectPaymentMethodsEntitiesState,
  fromPaymentmethod.selectPaymentMethodsError
);
